export const NAMESPACE = "AddQuestionSetModal";

export const HEIGHTS = {
  HEADER: 64,
  FOOTER: 89,
  BODY: 300
};
